import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function isPreviewEnvironment(): boolean {
  if (typeof window === 'undefined') return false;
  
  const hostname = window.location.hostname;
  
  // Detecta ambientes de preview/desenvolvimento
  return (
    hostname.includes('.lovable.app') ||
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.includes('.preview.') ||
    hostname.includes('.staging.')
  );
}

/**
 * Retorna a URL base da aplicação para redirecionamentos
 * Prioriza variável de ambiente, depois usa window.location.origin
 */
export function getAppBaseUrl(): string {
  if (typeof window === 'undefined') {
    return import.meta.env.VITE_APP_BASE_URL || 'https://app.auracode.io';
  }
  
  // Prioriza variável de ambiente configurada
  const envBaseUrl = import.meta.env.VITE_APP_BASE_URL;
  if (envBaseUrl) {
    return envBaseUrl;
  }
  
  // Fallback para origem atual (funciona em dev, preview e produção)
  return window.location.origin;
}
